import {
  BUSINESS_HOURS_WEEKDAYS,
  BUSINESS_HOURS_WEEKEND,
} from "../../constants/businessHours";

type BusinessHoursBlockProps = {
  className?: string;
  /** Nagłówek nad listą (np. „Godziny pracy”). */
  title?: string;
  titleClassName?: string;
  lineClassName?: string;
};

function BusinessHoursBlock({
  className = "",
  title = "Godziny pracy",
  titleClassName = "",
  lineClassName = "",
}: BusinessHoursBlockProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <p className={titleClassName}>{title}</p>
      <p className={lineClassName}>{BUSINESS_HOURS_WEEKDAYS}</p>
      <p className={lineClassName}>{BUSINESS_HOURS_WEEKEND}</p>
    </div>
  );
}

export default BusinessHoursBlock;
